class localhostSettings { }

const win: any = window;
if (window.location.href.includes("localhost")) {
  win["isLoggedIn"] = 'false';
  document.documentElement.lang = win["lang"];
  win["base_portal_url"] = "http://ssta004:8080";
  !!!win["base_api_url"] && (win["base_api_url"] = "https://apisit.mobily.com.sa/api");
  win["detailsURL"] = "details";

  if (!win["clientToken"]) {
    win["clientToken"] = "44f653e3-5915-42fc-95ec-45bd641bc7cb";
  }

  win['download_form_url'] = 'http://ssta004:8080/DigitalSales/';

  win['submit_order_page_url'] = 'http://ssta004:8080/wps/portal/web/business/manage-orders/fast-track-orders/details/fast-track-orders/fast-track-orders';
  win['track_order_page_url'] = 'http://ssta004:8080/wps/portal/web/business/manage-orders/track-my-orders/details/track-my-orders/track-my-orders';

  win['home_page_url'] = 'http://ssta004:8080/wps/portal/web/business';
  win['BM_PUBLIC_KEY'] = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCmPf3z814tRQn0Khn+dqMSEKdJ+inWbdk7cxjTtAMfGuU6tzh49NKWMsjtCwWzt49K/67x9Viod2n/efE6P3PmBMxSMlR623zzuiwI9WWPWIi0cJpYc38MPt6iL83qerxF1tx9DjA8wjooA5W7JdasihV83eTWCqCgqx4GkMMHvQIDAQAB";

  win['submit_order_thanku_url'] = 'http://ssta004:8080/wps/portal/web/business/manage-orders/thank-you';
  win['track_order_thanku_url'] = 'http://ssta004:8080/wps/portal/web/business/manage-orders/order-status';
  win['request_a_call_url'] = 'http://ssta004:8080/wps/portal/web/business/services/request-call/'

  win["regenerate_url"] = "/wps/portal/web/personal/store/cartmgmt/!ut/p/z1/jZDNDoIwEISfxSfo9oe211IQkBooBMVeDAdjMIoejM8vIerBCLK3Tb6Z3RnkUI1c1zzaY3Nvr11z7ved43uuPBJRwDlQA2DN0gsTYShEAm0HIMGpjleM5BkUFGzMfKZ1RmhCkJuj5zYIIe0ByUGCrYz25VpgUGKeHkZGwX-9G5BPAlmooEdgY0sT4LAUL2DsRUK-HX50MOmg3icmUpSHDt0uVVVDm5yYWjwBkQFJJA!!/dz/d5/L2dBISEvZ0FBIS9nQSEh/p0/IZ7_6A52G301P02H10QT8H4TPI0052=CZ6_6A52G301P03L00QLF5EI7L30G7=NJreGenerateToken=/";

  win["regenerate_apigee_url"] = "/wps/portal/web/business/manage-orders/track-my-orders/details/track-my-orders/track-my-orders/!ut/p/z1/jZBda8IwFIZ_iz-g5CTtmt6mWTExhlhZscuNBJ0aNlvpykB_vUHGwPl57s7L874XD7KoRrZxP37tet827iv87zadS6y4GCVkMhSMQ0klF2wKMZSAZueAgWmIRZInnBsSS4LsM_20fC1AAZ5kKWRQVmOeZ5piYPS5Ptw4Bo_6o0dAMEA6zfUa2Z3rN5FvVi2q-84tPqPtPmq75Uf3fRnMkL27zPAFALQIAAdTUR0z_fIL_LkxqQpucJHn6o0RZcj_hSvyzxeu2D0Bd_TttlVVH8YCvPSSDQZHZTRNwA!!/dz/d5/L2dBISEvZ0FBIS9nQSEh/p0/IZ7_I1KCHJ42PGHAC0Q7ICHAR03L92=CZ6_I1KCHJ42PGHAC0Q7ICHAR030Q0=NJreGenerateApigeeToken=/"
  win['errorPageUrl'] = 'http://ssta004:8080/wps/portal/web/personal/store/error';
}

export default localhostSettings;
